import { Signal } from "typed-signals";

import { Scene } from "onearm";
import { FlexContainer } from "onearm";
import { FullScreenBackgroundFill } from "onearm";

export class EmptyPopUpScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", ...parameters });
    }

    create(options) {
        super.create(options);

        const { screen } = options;

        this.fill = this.addChild(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        );
        this.root = this.createObject(FlexContainer, { size: screen.zone.fullScreen });
    }
}

export class BuyBonusPopUpScene extends EmptyPopUpScene {
    create(options) {
        super.create(options);

        this.onPressConfirmationOk = new Signal();
        this.onPressConfirmationCancel = new Signal();



        this.buyBonusPopUp = this.buildLayout("BuyBonusConfirmationLayout");

        this.buyBonusPopUp.forAll("OkButton", (btn) => {
            if (btn) {
                btn.onPress.connect((v) => this.onPressOk.emit(v));
            }
        });

        this.buyBonusPopUp.forAll("NoButton", (btn) => {
            if (btn) {
                btn.onPress.connect((v) => this.onPressCancel.emit(v));
            }
        });
    }

    setFreeSpins(value) {
        this.buyBonusPopUp.forAll("free_spins_text", (obj) => {
            if (obj) {
                obj.text = value;
            }
        });

        this.buyBonusPopUp.forAll("freeSpinsCountContainer", (obj) => {
            if (obj) {
                obj.layout();
            }
        });
    }

    setSelectedPrice(price) {
        this.buyBonusPopUp.forAll("cost_free_spins_text", (obj) => {
            if (obj) {
                obj.text = this.currencyFormatter.format(price);
            }
        });

        this.buyBonusPopUp.forAll("freeSpinsCoastContainer", (obj) => {
            if (obj) {
                obj.layout();
            }
        });
    }
}
